import React, { useEffect, useState } from "react";
import useCreateModal from "../hooks/useCreateModal";
import useHandleOpenObject from "../hooks/useHandleOpenObject";
import useSizePercentage from "../hooks/useSizePercentage";
import MainStore from "../stores/MainStore";
import NotText from "./NotText";
import SideCounter from "./SideCounter";

const SideBar = ({
  counter,
  type,
  place,
  onSidebarClicked,
  typeIcon,
  objects,
}) => {
  const { displayedBoxes } = MainStore();
  const sizePercentage = useSizePercentage();
  const [resizingBoxes, setResizingBoxes] = useState();

  const counterBackground = {
    problem: "#282828",
  };
  const counterTextColor = {
    problem: "white",
  };

  useEffect(() => {
    setResizingBoxes(displayedBoxes.length > 3);
  }, [displayedBoxes]);

  return (
    <div
      className="divColumn"
      style={{
        width:
          displayedBoxes.length < 4
            ? "50px"
            : `${(50 / 100) * sizePercentage.total}px`,
        height:
          displayedBoxes.length < 4
            ? "100%"
            : `${(50 / 100) * sizePercentage.total}px`,
      }}
    >
      <img
        style={{
          marginTop: "2px",
          objectFit: "contain",
          height: resizingBoxes
            ? `${(20 / 100) * sizePercentage.total}px`
            : "20px",
        }}
        src={typeIcon}
      />
      <div className="divColumn" style={{ flex: 1, marginTop: "5px" }}>
        {counter.map((c) => (
          <SideCounter
            key={c.image}
            image={c.image}
            counter={c.counter}
            hoverDescription={c.hoverDescription}
            backgroundColor={counterBackground[type]}
            textColor={counterTextColor[type]}
            resizingBoxes={resizingBoxes}
            sizePercentage={sizePercentage}
          />
        ))}
      </div>
      {counter.length < 1 && (
        <NotText
          onSidebarClicked={onSidebarClicked}
          place={place}
          resizingBoxes={resizingBoxes}
          sizePercentage={sizePercentage}
        />
      )}
    </div>
  );
};

export default SideBar;
